module.exports = __webpack_public_path__ + "img/ai.8ddd6194.png";